module.exports = __webpack_public_path__ + "img/logo-bare.adcb6b77.png";